<template>
  <div class="anntd">
    <div class="nav acea-row">
      <div class="annt-goback" @click="goBack()">
        <div class="iconfont icon-jiantou-left">
          <span>返回</span>
        </div>
      </div>
      <div class="item">
        公告详情
      </div>
    </div>
    <div class="annt-detail">
      <div class="cont">
        <div class="annt-title">
          {{ announcement.titile }}
        </div>
        <div class="annt-send">
          {{ announcement.sendTime }}
        </div>
        <div class="annt-msg">
          <div class="conter" v-html="announcement.msgContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAnnouncement } from "@api/announcement";
export default {
  name: "AnnouncementDetail",
  data: function() {
    return {
      unique: "",
      announcement: {}
    };
  },
  mounted() {
    let that = this;
    that.unique = that.$route.params.unique;
    that.getAnnouncement(that.$route.params.unique);
  },
  methods: {
    goBack() {
      this.$router.push("/announcement");
    },
    getAnnouncement(unique) {
      let that = this;
      getAnnouncement({ unique: unique })
        .then(res => {
          that.announcement = res.data;
        })
        .catch(err => {
          that.$dialog.message(err.msg);
          this.goBack();
        });
    }
  }
};
</script>

<style></style>
